export const createExtendedLinearRampToValueAutomationEvent = (value, endTime, insertTime) => {
    return { endTime, insertTime, type: 'linearRampToValue', value };
};
//# sourceMappingURL=create-extended-linear-ramp-to-value-automation-event.js.map